/**
 * NOTE:
 *
 * This file is automatically generated.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index in @atlassian/proforma-utils.
 */
var lazyMessages = {
  cs: function cs() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/cs" */'./cs');
  },
  da: function da() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/da" */'./da');
  },
  de: function de() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/de" */'./de');
  },
  en: function en() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/en" */'./en');
  },
  en_GB: function en_GB() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/en_GB" */'./en_GB');
  },
  en_ZZ: function en_ZZ() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/en_ZZ" */'./en_ZZ');
  },
  es: function es() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/es" */'./es');
  },
  fi: function fi() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/fi" */'./fi');
  },
  fr: function fr() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/fr" */'./fr');
  },
  hu: function hu() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/hu" */'./hu');
  },
  it: function it() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/it" */'./it');
  },
  ja: function ja() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/ja" */'./ja');
  },
  ko: function ko() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/ko" */'./ko');
  },
  nb: function nb() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/nb" */'./nb');
  },
  nl: function nl() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/nl" */'./nl');
  },
  pl: function pl() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/pl" */'./pl');
  },
  pt_BR: function pt_BR() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/pt_BR" */'./pt_BR');
  },
  ru: function ru() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/ru" */'./ru');
  },
  sv: function sv() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/sv" */'./sv');
  },
  th: function th() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/th" */'./th');
  },
  tr: function tr() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/tr" */'./tr');
  },
  uk: function uk() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/uk" */'./uk');
  },
  vi: function vi() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/vi" */'./vi');
  },
  zh: function zh() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/zh" */'./zh');
  },
  zh_TW: function zh_TW() {
    return import( /* webpackChunkName: "@atlaskit-internal_proforma-common-core/locale/zh_TW" */'./zh_TW');
  }
};
export default lazyMessages;